import triggerCustomGaEvent from '../utilities/analytics/triggerCustomGaEvent'

export const SET_PROFILE_MODAL_VISIBILITY = 'SET_PROFILE_MODAL_VISIBILITY'
export const SET_PROFILE_AUTHENTICATION = 'SET_PROFILE_AUTHENTICATION'

export const setModalVisibility = profileModalVisibility => ({
	type: SET_PROFILE_MODAL_VISIBILITY,
	payload: profileModalVisibility
})
export const setAuthentication = profileAuthentication => ({
	type: SET_PROFILE_AUTHENTICATION,
	payload: profileAuthentication
})

export function setProfileModalVisibility(profileModalVisibility) {
	return (dispatch) => {
		const profileModalVisibilityData = {
			visible: profileModalVisibility
		}
		triggerCustomGaEvent('analytics-profileModalVisibility', profileModalVisibilityData)

		dispatch(setModalVisibility(profileModalVisibility))
	}
}

export function setProfileAuthentication(profileAuthentication) {
	return (dispatch) => {
		const profileModalAuthenticationData = {
			isProfileAuthenticated: profileAuthentication
		}
		triggerCustomGaEvent('analytics-profileModalAuthentication', profileModalAuthenticationData)

		dispatch(setAuthentication(profileAuthentication))
	}
}





// WEBPACK FOOTER //
// ./src/actions/setProfile.js